import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/index/index'
import Welcome from '@/components/welcome/welcome'
import Students from '@/components/students/students-list'

Vue.use(Router)
// 获取原型对象上的push函数
const originalPush = Router.prototype.push
// 修改原型对象中的push方法
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  routes: [
    {
      path: '/index',
      component: Index,
      children: [
        {
          path: '/',
          component: Welcome
        },
        // {
        //   path: '/students',
        //   name: '学生管理',
        //   component: Students
        // },
        {
          path: '/addStudent',
          name: '新学生',
          component: resolve => require(['@/components/students/add'], resolve)
        },
        {
          path: '/detail/:id',
          name: '详情',
          component: resolve => require(['@/components/students/detail'], resolve)
        },
        {
          path: '/scorestandard',
          name: '评分标准',
          component: resolve => require(['@/components/school-score-standard/school-score-standard'], resolve)
        },
        {
          path: '/projectweight',
          name: '项目权重',
          component: resolve => require(['@/components/school-project-weight/school-project-weight'], resolve)
        },
        {
          path: '/dataCollection',
          name: '体适能数据汇总',
          component: resolve => require(['@/components/data-collection/data-collection'], resolve)
        },
        {
          path: '/dataAnalysis',
          name: '体测分析',
          component: resolve => require(['@/components/data-test-analysis/data-test-analysis'], resolve)
        },
        {
          path: '/content',
          name: '内容管理',
          component: resolve => require(['@/components/content/content'], resolve)
        },
        {
          path: '/addContent',
          name: '内容新增',
          component: resolve => require(['@/components/addContent/addContent'], resolve)
        },
        {
          path: '/editContent',
          name: '内容编辑',
          component: resolve => require(['@/components/editContent/editContent'], resolve)
        },
        {
          path: '/action',
          name: '运动库管理',
          component: resolve => require(['@/components/action/action'], resolve)
        },
        {
          path: '/addAction',
          name: '运动新增',
          component: resolve => require(['@/components/addAction/addAction'], resolve)
        },
        {
          path: '/editAction',
          name: '运动编辑',
          component: resolve => require(['@/components/editAction/editAction'], resolve)
        },
        {
          path: '/question',
          name: '试题库管理',
          component: resolve => require(['@/components/question/question'], resolve)
        },
        {
          path: '/addQuestion',
          name: '试题新增',
          component: resolve => require(['@/components/question/addQuestion'], resolve)
        },
        {
          path: '/editQuestion',
          name: '试题编辑',
          component: resolve => require(['@/components/question/editQuestion'], resolve)
        },
        {
          path: '/tmf',
          name: '战备箱数据',
          component: resolve => require(['@/components/tmf/tmf'], resolve)
        },
        {
          path: '/view',
          name: '意见反馈',
          component: resolve => require(['@/components/view/view'], resolve)
        },
        {
          path: '/exercise',
          name: '运动处方',
          component: resolve => require(['@/components/exercise/exercise'], resolve)
        },

        {
          path: '/healthdata',
          name: '健康档案',
          component: resolve => require(['@/components/healthdata/healthdata'], resolve)
        },

        {
          path: '/reportEcharts',
          name: '历史',
          component: resolve => require(['@/components/eChartsReport/eChartReport'], resolve)
        },
        {
          path: '/easyUp',
          name: '提升分析',
          component: resolve => require(['@/components/easyUp/easyUp'], resolve)
        },
        {
          path: '/easyDown',
          name: '下降分析',
          component: resolve => require(['@/components/easyDown/easyDown'], resolve)
        },
        {
          path: '/testSearch',
          name: '体测助手',
          component: resolve => require(['@/components/testSearch/testSearch'], resolve)
        },
        {
          path: '/weChat',
          name: '用户统计',
          component: resolve => require(['@/components/weChat/weChat'], resolve)
        },
        {
          path: '/history',
          name: '历史趋势',
          component: resolve => require(['@/components/history/history'], resolve)
        },
        {
          path: '/notice',
          name: '系统通知',
          component: resolve => require(['@/components/notice/notice'], resolve)
        },
        {
          path: '/addTice',
          name: '新增通知',
          component: resolve => require(['@/components/addTice/addTice'], resolve)
        },
        {
          path: '/inforMenu',
          name: '资讯菜单',
          component: resolve => require(['@/components/inforMenu/inforMenu'], resolve)
        },
        {
          path: '/fitness',
          name: '体适能测试',
          component: resolve => require(['@/components/fitness/fitness'], resolve)
        },
        {
          path: '/fitnessfive',
          name: '体测成绩',
          component: resolve => require(['@/components/fitness/fitness-five'], resolve)
        },
        {
          path: '/fitnesssreport',
          name: '体测报告',
          component: resolve => require(['@/components/fitness/fitness-report'], resolve)
        },
        {
          path: '/changePerInfo',
          name: '编辑资料',
          component: resolve => require(['@/components/change-per-info/change-per-info'], resolve)
        },
        {
          path: '/changePassword',
          component: resolve => require(['@/components/change-password/change-password'], resolve)
        },
        {
          path: '/changeRole',
          component: resolve => require(['@/components/change-role/change-role'], resolve)
        },
        {
          path: '/staff',
          name: '全部职工',
          component: resolve => require(['@/components/staff/staff'], resolve)
        },
        {
          path: '/roles',
          name: '角色管理',
          component: resolve => require(['@/components/sys-roles/sys-roles'], resolve)
        },
        {
          path: '/users',
          name: '账户管理',
          component: resolve => require(['@/components/sys-users/sys-users'], resolve)
        },
        {
          path: '/region',
          name: '区域管理',
          component: resolve => require(['@/components/sys-region/sys-region'], resolve)
        },
        // {
        //   path: '/schoolManage',
        //   name: '学校管理',
        //   component: resolve => require(['@/components/school-manage/school-manage'], resolve)
        // },
        // {
        //   path: '/gradeManage',
        //   name: '年级管理',
        //   component: resolve => require(['@/components/grade-manage/grade-manage'], resolve)
        // },
        {
          path: '/classList',
          name: '班级列表',
          component: resolve => require(['@/components/class-list/class-list'], resolve)
        },
        {
          path: '/menu',
          name: '菜单管理',
          component: resolve => require(['@/components/sys-menu/sys-menu'], resolve)
        },
        {
          path: '/classManage',
          name: '班级管理',
          component: resolve => require(['@/components/school-class-manage/school-class-manage'], resolve)
        },
        {
          path: '/gradeInfoManage',
          name: '年级管理',
          component: resolve => require(['@/components/school-grade-manage/school-grade-manage'], resolve)
        },
        {
          path: '/testProject',
          name: '体测项目',
          component: resolve => require(['@/components/school-test-project/school-test-project'], resolve)
        },
        {
          path: '/dataJump',
          name: '原地纵跳',
          component: resolve => require(['@/components/data-jump/data-jump'], resolve)
        },
        {
          path: '/dataHeight',
          name: '身高',
          component: resolve => require(['@/components/data-height/data-height'], resolve)
        },
        {
          path: '/dataWeight',
          name: '体重',
          component: resolve => require(['@/components/data-weight/data-weight'], resolve)
        },
        {
          path: '/dataBMI',
          name: 'BMI',
          component: resolve => require(['@/components/data-BMI/data-BMI'], resolve)
        },
        {
          path: '/dataVital',
          name: '肺活量',
          component: resolve => require(['@/components/data-vital/data-vital'], resolve)
        },
        {
          path: '/dataGrip',
          name: '握力',
          component: resolve => require(['@/components/data-grip/data-grip'], resolve)
        },
        {
          path: '/dataReaction',
          name: '反应能力',
          component: resolve => require(['@/components/data-reaction/data-reaction'], resolve)
        },
        {
          path: '/dataBalance',
          name: '平衡能力',
          component: resolve => require(['@/components/data-balance/data-balance'], resolve)
        },
        {
          path: '/schoolAdmin',
          name: '学校管理',
          component: resolve => require(['@/components/school-admin/school-admin'], resolve)
        },
        {
          path: '/studentAdmin',
          name: '学生管理',
          component: resolve => require(['@/components/student-admin/student-admin'], resolve)
        },
        {
          path: '/teachDetail',
          name: '教师详情',
          component: resolve => require(['@/components/teacher-detail/teacher-detail'], resolve)
        },
        {
          path: '/teacherAdd',
          name: '教师添加',
          component: resolve => require(['@/components/teacher-add/teacher-add'], resolve)
        },
        {
          path: '/teachAdmin',
          name: '教师管理',
          component: resolve => require(['@/components/teach-admin/teach-admin'], resolve)
        },
        // {
        //   path: '/teachAdminUser',
        //   name: '教师管理',
        //   component: resolve => require(['@/components/teach-admin-user/teach-admin-user'], resolve)
        // },
        {
          path: '/dailyAdmin',
          name: '体育作业',
          component: resolve => require(['@/components/daily-admin/daily-admin'], resolve)
        },
        {
          path: '/statistics',
          name: '作业统计',
          component: resolve => require(['@/components/statistics/statistics'], resolve)
        },
        {
          path: '/dataRun',
          name: '体测数据采集',
          component: resolve => require(['@/components/data-run/data-run'], resolve)
        },
        {
          path: '/reportAdmin',
          name: '分析报告',
          component: resolve => require(['@/components/report-admin/report-admin'], resolve)
        },
        {
          path: '/reportDetail',
          name: '数据详情',
          component: resolve => require(['@/components/report-detail/report-detail'], resolve)
        },
        {
          path: '/dataStats',
          name: '数据看板',
          component: resolve => require(['@/components/data-stats/data-stats'], resolve)
        },
        {
          path: '/march',
          name: '签到管理',
          component: resolve => require(['@/components/march/march'], resolve)
        },
        {
          path: '/information',
          name: '导入学生',
          component: resolve => require(['@/components/infor/information'], resolve)
        },
        {
          path: '/listDetail',
          name: '个人信息',
          component: resolve => require(['@/components/list-detail/listDetail'], resolve)
        },
        {
          path: '/listHistory',
          name: '体测历史',
          component: resolve => require(['@/components/list-history/listHistory'], resolve)
        },
        {
          path: '/personalData',
          name: '成绩查询',
          component: resolve => require(['@/components/personal-data/personalData'], resolve)
         /*  meta: {
            keepAlive: true
          } */
        },
        {
          path: '/pointMent',
          name: '预约管理',
          component: resolve => require(['@/components/point-ment/pointMent'], resolve)
        },
        {
          path: '/export',
          name: '导出学生',
          component: resolve => require(['@/components/export/export'], resolve)
        },
        {
          path: '/eyesight',
          name: '视力数据',
          component: resolve => require(['@/components/eyesight/eyesight'], resolve)
        },
        {
          path: '/eyesight-ds',
          name: '视力统计',
          component: resolve => require(['@/components/eyesight/eyesight-ds'], resolve)
        },
        {
          path: '/eyesight-collection',
          name: '视力数据采集',
          component: resolve => require(['@/components/eyesight/eyesight-collection'], resolve)
        },
        {
          path: '/trend',
          name: '趋势分析',
          component: resolve => require(['@/components/trend/trend'], resolve)
        },

        {
          path: '/achievement',
          name: '成绩导入',
          component: resolve => require(['@/components/achievement/achievement'], resolve)
        },
        {
          path: '/teamSkipping',
          name: '团体跳绳',
          component: resolve => require(['@/components/teamSkipping/teamSkipping'], resolve)
        }
      ]
    },
    {
      path: '/',
      name: '宁教云登录',
      component: resolve => require(['@/components/oauth2/njy/login'], resolve)
    },
    // {
    //   path: '/',
    //   name: '登录',
    //   component: resolve => require(['@/components/login/login'], resolve)
    // },
    {
      path: '/login',
      name: '登录',
      component: resolve => require(['@/components/login/login'], resolve)
    },
    // {
    //   path: '/speech',
    //   name: '体质监测分析报告',
    //   component: resolve => require(['@/components/speech/speech'], resolve)
    // },
    {
      path: '/report/:id',
      component: resolve => require(['@/components/students/report'], resolve)
    },
    {
      path: '/dataBoard',
      name: '数据大屏',
      component: resolve => require(['@/components/data-stats/data-board'], resolve)
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js